import { z } from "zod";
import { useCallback, useEffect, useState } from "react";
import useChangeEmail from "@/domains/playerMenu/hooks/useChangeEmail";
import PlayerMenuSettingsSafetyEnterCurrEmail from "@/domains/playerMenu/components/settings/safety/changeEmail/PlayerMenuSettingsSafetyEnterCurrEmail";

const emailSchema = z.string().email({ message: "Некорректный email" });

type Props = {
  onCancel: () => void;
  next: () => void;
  onChangeCurrEmail: (value: string) => void;
};

export default function PlayerMenuSettingsSafetyEnterCurrEmailContainer({
  onCancel,
  next,
  onChangeCurrEmail,
}: Props) {
  const { sendOldCodeHandler, sendOldError, sendOldIsCompleted, sendOldIsPending } =
    useChangeEmail();
  const [currEmail, setCurrEmail] = useState("");
  const [validationErrorCurrEmail, setValidationErrorCurrEmail] = useState("");

  useEffect(() => {
    if (currEmail) {
      try {
        setValidationErrorCurrEmail("");
        emailSchema.parse(currEmail);
      } catch (error) {
        if (error instanceof z.ZodError) {
          setValidationErrorCurrEmail(error.errors[0].message);
        }
      }
    } else {
      setValidationErrorCurrEmail("");
    }
  }, [currEmail]);

  const onContinue = useCallback(() => {
    sendOldCodeHandler(currEmail);
  }, [sendOldCodeHandler, currEmail]);

  useEffect(() => {
    if (sendOldIsCompleted) {
      onChangeCurrEmail(currEmail);
      next();
    }
  }, [sendOldIsCompleted, next, currEmail, onChangeCurrEmail]);

  return (
    <PlayerMenuSettingsSafetyEnterCurrEmail
      onCancel={onCancel}
      onContinue={onContinue}
      email={currEmail}
      onChangeEmail={setCurrEmail}
      error={sendOldError || validationErrorCurrEmail}
      loading={sendOldIsPending}
    />
  );
}
